export default {
  hasEmailFlow (state) {
    return state.linkingStatusCode === 'ready_to_link'
  },
  isAlreadyLinked (state) {
    return state.linkingStatusCode === 'linked'
  }
}
